











































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import TreeHierarchy from '@/components/TreeHierarchy.vue';
import MaterialsListPrintTool from '@/components/MaterialsListPrintTool.vue';
import { ClaimEnum } from '@/services/ClaimEnum';
import {ProductBase} from '@/entity/ProductBase';
import { IMaterialDto } from '@/interfaces/IMaterialDto';

@Component({
    components: {
        TreeHierarchy,
        MaterialsListPrintTool
    }
})
export default class ProductAddDetail extends Vue {
    @Prop()
    public idproduct!: any;

    @Prop()
    idModel: string;

    @Prop()
    showClose: boolean;
    tabActivated: number = 0;
    loading: boolean = false;
    checkingProductCode: boolean = false;
    isValidProductCode: boolean = false;
    isSaveClicked: boolean = false;
    product: any = {};
    general: any = {};
    publicOptions = [
      { value: true, text: 'PUBLIC'},
      { value: false, text: 'NON PUBLIC' }
    ]
    materialList: IMaterialDto[] = [];

    close() {
        this.$bvModal.hide('product-add-detail-modal');
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    async checkProductCode() {
        this.checkingProductCode = true;
        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/product/IsExistingProduct?productCode=' + this.product.code.trim()),
                responseType: 'json',
                withCredentials: true
            });
            if (response.data) {
                General.showAlertDanger("Product with code " + this.product.code + " already exists", this);
                this.isSaveClicked = true;
                this.isValidProductCode = false;
            } else {
                this.isValidProductCode = true;
            } 
        } catch (error) {
            General.HandleError(error, this, true);
        } finally {
            this.checkingProductCode = false;
        }
    }
    async createProduct(){
        let app = this;
        let callSaving = async () =>  {
            await app.createProductDo();
        }
        General.confirm('Please confirm that you want to add this product.', app, callSaving);

    }

    afterMaterialDetailAddProduct(newMaterialList) {
        this.product.materials = newMaterialList;
    }

    async createProductDo(){
        this.isSaveClicked = true;
        let app = this;
        if(!this.isValidProductCode) {
            General.showAlertDanger("Invalid product code, please check", app);
        } else if(this.product.treeHierarchyCode != undefined && this.product.treeHierarchyCode.length < 18 && this.product.treeHierarchyCode.length > 0) {
            General.showAlertDanger("Invalid Hierarchy code: mandatory 18 characters string or empty", app);
        } else if(this.product.isPublic === undefined) {
            General.showAlertDanger("Please check Required fields", app);
        } else {
            General.mainLoading(true);
            let productBase = new ProductBase();
            productBase.Code = this.product.code.trim();
            productBase.OldCode = this.product.oldCode;
            productBase.Description = this.product.description;
            productBase.TreeHierarchyCode = this.product.treeHierarchyCode;
            productBase.Approvals = this.product.approvals;
            productBase.Viscosity = this.product.viscosity;
            productBase.TechSpecs = this.product.techSpecs;
            productBase.PerformanceLevel = this.product.performanceLevel;
            productBase.IsPublic = this.product.isPublic;
            productBase.ImportedFromSAP = false;
            
            if(this.product.materials !== undefined) {
                let materialList: IMaterialDto[] = [];
                this.product.materials.forEach(element => {
                var newMaterial: IMaterialDto = {};
                    newMaterial.materialCode = element.materialCode;
                    newMaterial.description = element.description;
                    newMaterial.isDead = element.isDead;
                    newMaterial.isPhaseOut = element.isPhaseOut;
                    newMaterial.originalDescription = element.originalDescription;
                    newMaterial.packageCode = element.packageCode;
                    newMaterial.barCode = "";
                    materialList.push(newMaterial);
                });
                productBase.Materials = materialList;
            }
            
            try{
                let response = await axios.post(General.GetApiUrl('/api/product/AddProduct'),productBase,{ withCredentials: true });
                var idProduct = response.data;

                app.$emit("postAddProduct", {idProduct: idProduct, code: productBase.Code});
                this.isSaveClicked = false;
                this.close();
            }catch(error){
                General.HandleError(error, app, true);
            }
            General.mainLoading(false); 
        }
    }

    get showSave(): boolean{
        return this.editBaseInfo||this.editTechSpecs;
    }

    get editBaseInfo(): boolean{
        let isUserAuthorized = General.CheckAuthorization(ClaimEnum.CanEditProduct);
        let isProductManagedBySAP = this.product.importedFromSAP;
        return (isUserAuthorized && !isProductManagedBySAP)
    }

    get editTechSpecs(): boolean{
        let isUserAuthorized = General.CheckAuthorization(ClaimEnum.CanUploadTechSpecs);           

        return isUserAuthorized;
    }
    mounted() {
        this.tabActivated = 0;
    }
}
